import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import logo from '../Assets/images/ignio-high-resolution-logo-transparent.png';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { useEffect, useState } from 'react';
import '../Assets/styles/nav.css';

function Nav1() {
  const [showDropdown, setShowDropdown] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const mouseOver = () => {
    setShowDropdown(true);
  };

  const mouseOut = () => {
    setShowDropdown(false);
  };

  useEffect(() => {
    const handleScrolled = () => {
      (window.scrollY > 100) ? setScrolled(true) : setScrolled(false)
    };

    window.addEventListener('scroll', handleScrolled);

    return () => window.removeEventListener('scroll', handleScrolled);
  }, []);

  return (
    <Navbar expand="lg" className={`nav-justified fixed-top ${scrolled ? "move" : ""}`}>
      <Container className="convict">
        <Navbar.Brand href="/" className="me-auto logo">
          <img src={logo} alt="logo" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto main-na">
            {/* <Nav.Link href="/home" className='nav-item'>Home</Nav.Link> */}
            <Nav.Link href="/about" className='nav-item'>About</Nav.Link>
            {/* <Nav.Link href="/services" className='nav-item'>Services</Nav.Link> */}
            <Nav.Link href="/" className='nav-item'>Project</Nav.Link>
            <NavDropdown
              title="Pages"
              id="basic-nav-dropdown navdrop"
              className='bx bx-chevron-down amuyet menu-item menu-item-has-children'
              show={showDropdown}
              onMouseEnter={mouseOver}
              onMouseLeave={mouseOut}
            >
              <div className="sub-menu">
                <NavDropdown.Item href="/Ourteam" className='text_hover_effect'>Our Team</NavDropdown.Item>
                <NavDropdown.Item href="/faq" className='text_hover_effect'>FAQ</NavDropdown.Item>
                <NavDropdown.Item href="/privacy" className='text_hover_effect'>Privacy Policy</NavDropdown.Item>
                <NavDropdown.Item href="/t&c" className='text_hover_effect'>Terms & Conditions</NavDropdown.Item>
              </div>
            </NavDropdown>
            <Nav.Link href="/contact" className='nav-item'>Contact</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Nav1;
